import { useState } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import TextField from 'modules/core/components/TextField'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import DirectUploader from 'modules/trainings/components/Files/Uploaders/DirectUploader'
import Uploader from 'modules/trainings/components/Files/Uploaders/Uploader'
import { UploadValue } from 'modules/trainings/components/Files/types'

import { FileSubmissionData } from './types'

type FileTypeCategory = 'document' | 'image' | 'video' | 'text'

export const NewFileModal = ({
  onClose,
  onSubmit,
  resourceType,
  resourceId,
  title: modalTitle,
  noTitleField: noTitle,
  fileTypes = ['document', 'image', 'video', 'text'],
  description,
}: {
  noTitleField?: boolean
  onClose: () => void
  onSubmit: (data: FileSubmissionData) => Promise<unknown>
  description: string
  title: string
  resourceId?: string
  resourceType: 'Trainings::Training' | 'Trainings::TrainingClass' | 'Trainings::TrainingMembership'
  fileTypes?: FileTypeCategory[] // Categories of files to accept
}) => {
  const { access } = useCurrentSession()
  const [title, setTitle] = useState<string>()
  const [upload, setUpload] = useState<UploadValue>()

  const uplodaerDescription = fileTypes.includes('video')
    ? i18n.t('trainings.trainings_files_modal.size_description_video')
    : i18n.t('trainings.trainings_files_modal.size_description_all')

  const ActualFileUploader =
    resourceType === 'Trainings::TrainingMembership' ? (
      <Uploader
        onUpload={(uploadData) => {
          setUpload(uploadData)
        }}
        description={uplodaerDescription}
        fileTypes={fileTypes}
      />
    ) : (
      <DirectUploader
        onUpload={(uploadData) => {
          setUpload(uploadData)
        }}
        description={uplodaerDescription}
        fileTypes={fileTypes}
        resourceType={resourceType}
        resourceId={resourceId}
      />
    )

  return (
    <Modal
      illustration="upload"
      description={description}
      title={modalTitle}
      onClose={onClose}
      onSubmit={async () => {
        if (!upload) throw new Error('No file uploaded when submitting the form')

        await onSubmit({
          ...upload,
          title,
          authorId: access.id,
          type: upload.signedId ? 'signedId' : 'file',
        })
      }}
      footer={
        <Button disabled={!upload} submit>
          {i18n.t('trainings.trainings_files_modal.save')}
        </Button>
      }
    >
      <Box gap="s16">
        {!noTitle && (
          <TextField
            value={title}
            onChange={(value) => setTitle(value)}
            label={i18n.t('trainings.trainings_files_modal.field_title')}
          />
        )}
        {ActualFileUploader}
      </Box>
    </Modal>
  )
}
